import { useEffect, useState } from 'react'
import { useBlocker } from 'react-router-dom'
import { Modal, Typography, Button } from '@frontend/design_system'
import styles from './styles.module.scss'
import { CustomBlocker, UnsavedChangesModalProps } from './types'
import {
  UNSAVED_MODAL_LEAVE_LABEL,
  UNSAVED_MODAL_QUESTION,
  UNSAVED_MODAL_TITLE,
  UNSAVED_MODAL_UNSAVED_CHANGES,
} from 'texts/unsavedModal'
import { CANCEL } from 'texts/uiTexts'

export const UnsavedChangesModal = ({
  isDirty = false,
  customBlockers = [],
}: UnsavedChangesModalProps) => {
  const [showModal, setShowModal] = useState(false)
  const [activeCustomBlocker, setActiveCustomBlocker] =
    useState<CustomBlocker | null>(null)
  const blocker = useBlocker(isDirty)

  useEffect(() => {
    if (blocker.state === 'blocked') {
      setShowModal(true)
      setActiveCustomBlocker(null)
    } else if (blocker.state === 'unblocked') {
      setShowModal(false)
    }
  }, [blocker, isDirty])

  useEffect(() => {
    const blockedCustomBlocker = customBlockers.find(
      (blocker) => blocker.isBlocked
    )
    if (blockedCustomBlocker && !showModal) {
      setActiveCustomBlocker(blockedCustomBlocker)
      setShowModal(true)
    }
  }, [customBlockers, showModal])

  const handleStay = () => {
    setShowModal(false)
    setActiveCustomBlocker(null)

    if (activeCustomBlocker) {
      activeCustomBlocker.onReset()
    } else {
      blocker.reset?.()
    }
  }

  const handleLeave = () => {
    setShowModal(false)
    setActiveCustomBlocker(null)

    if (activeCustomBlocker) {
      activeCustomBlocker.onProceed()
    } else {
      if (blocker.state === 'blocked') {
        blocker.proceed?.()
      }
    }
  }

  if (!showModal) return null

  return (
    <Modal
      position="center-horizontal"
      onClose={handleStay}
      headerSize="large"
      title={UNSAVED_MODAL_TITLE}
      isDelimiter
    >
      <div className={styles.content}>
        <Typography name="body1WMedium" color="grey500">
          {UNSAVED_MODAL_QUESTION}
        </Typography>
        <Typography name="body1WMedium" color="grey500">
          {UNSAVED_MODAL_UNSAVED_CHANGES}
        </Typography>
        <div className={styles.buttons}>
          <Button
            onClick={handleStay}
            label={CANCEL}
            variant="secondary-border"
            size="large"
            widthClassName={styles.button}
          />
          <Button
            onClick={handleLeave}
            label={UNSAVED_MODAL_LEAVE_LABEL}
            size="large"
            widthClassName={styles.button}
          />
        </div>
      </div>
    </Modal>
  )
}
